export default __webpack_public_path__ + "static/media/misc-pantry1-2048w.e7338b58.webp";